import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../layout";
import { Button } from "../../controls";
import { IconButton, Tooltip } from "@mui/material";
import { PlayCircleFilledRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import UnfreezeForm from "./UnfreezeForm";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import moment from "moment";
import { useTranslation } from "react-i18next";

const FreezeMembers = (props) => {
  const { memberId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showUnfreeze, setShowUnfreeze] = useState(false);
  const { branch, setLoader } = useContext(AppContext);
  const [freezeDtls, setFreezeDtls] = useState();
  const [tblData, setTblData] = useState([]);
  const [tblHeader, setTblHeader] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    var memberKeys = [
      { id: "memberId", label: t("MemberId") },
      { id: "name", label: t("Name") },
      { id: "freezeType", label: t("ChargeType") },
    ];
    var freezeKeys = [
      { id: "package", label: t("PackageName") },
      { id: "amt", label: t("Amount") },
      { id: "duration", label: t("Freeze") },
      { id: "date", label: t("FreezeDate") },
      { id: "actions", label: t("Actions") },
    ];
    !memberId
      ? setTblHeader([...memberKeys, ...freezeKeys])
      : setTblHeader([...freezeKeys]);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberId]);

  const handleViewMember = (id) => {
    navigate(`/view_member_profile/${id}`);
  };

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.Freeze + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res.status === 200 && setTblData([...res.result]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const handleAddEdit = () => {
    navigate(`/freeze_form/${memberId || ""}`);
  };

  const handleUnfreeze = (data) => {
    setShowUnfreeze(true);
    setFreezeDtls(data);
  };

  const ActionComp = (props) =>
    props.status === 1 ? (
      <div className="bs-secondary br-8 w-fit">
        <Tooltip title={t("UnfreezeMember")}>
          <IconButton
            onClick={() => handleUnfreeze(props)}
            size="small"
            color="primary"
            className="p-5"
          >
            <PlayCircleFilledRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      </div>
    ) : (
      <span className="fs-12 fw-5 bg-success white-color p-5 w-fit br-8 tx-upp">
        {t("Unfreeze")}
      </span>
    );

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>{t("AddFreeze")}</Button>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={tblHeader}
        tblData={tblData.map((j) => {
          return {
            ...j,
            memberId: j.member.memberId,
            name: (
              <span
                className="link"
                onClick={() => handleViewMember(j.memberId)}
              >
                {j.member.firstName + " " + j.member.lastName}
              </span>
            ),
            package: j.inv && j.inv.title,
            amt: `${j.amount || 0} ${branch && branch.currency}`,
            duration:
              moment(new Date(j.endDate)).diff(
                moment(new Date(j.startDate)),
                "days"
              ) + " Days",
            date: (
              <div className="d-grid fs-14 w-fit">
                <span>
                  <span className="fw-5">{t("Start")}:</span>
                  {j.startDate}
                </span>
                <span>
                  <span className="fw-5">{t("End")}:</span> {j.endDate}
                </span>
              </div>
            ),
          };
        })}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />

      {/* Unfreeze */}
      {showUnfreeze && (
        <Dialog show={showUnfreeze} onClose={false} maxWidth="sm">
          <UnfreezeForm
            {...{
              setShowForm: setShowUnfreeze,
              setAlert,
              freezeDtls,
              setTblData,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default FreezeMembers;
